import { TimelinePipe } from "@pnp/core";
import { Picker } from "../Picker";

export function LogNotifications(): TimelinePipe<Picker> {

    return (instance: Picker) => {
        instance.on.notification(async function (this: Picker, message) {
            this.log(`[${message.timestamp}] ${message.message}`, message.isExpected ? 0 : 1);
        });
        return instance;
    };
}
